import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineOnlyTextProps } from './types';
import { isNil } from '../../../../utils';

export const HeadlineOnlyText = ({ header }: HeadlineOnlyTextProps) => {
  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ horizontal: 16, top: 16, bottom: 8 }}
      justifyContent="flex-end"
      alignItems="center"
    >
      <Typography type="body3" color="content_tertiary">
        {header.item.title}
      </Typography>
    </Flex.Row>
  );
};
